import React from 'react'
import {
    AutocompleteField,
    SelectField,
    FileUpload
} from 'components/CustomFields'
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import formModel from 'containers/Onboarding/FormModels/Models';
import ListCountry from 'constants/Countries/countries'
import {
    ID_TYPE_OPTIONS
} from 'constants/Options/options'
import { Trans } from 'react-i18next'
import { useFormikContext } from 'formik'
import {
    usePassport
} from 'hooks/useKYC'
import dataStorage from 'dataStorage'

const { formField } = formModel

const countries = [
    { code: 'AU', value: 'AUS', label: 'Australia', phone: '61' },
    { code: 'AT', value: 'AUT', label: 'Austria', phone: '43' },
    { code: 'BE', value: 'BEL', label: 'Belgium', phone: '32' },
    { code: 'CA', value: 'CAN', label: 'Canada', phone: '1' },
    { code: 'IE', value: 'IRL', label: 'Ireland', phone: '353' },
    { code: 'IL', value: 'ISR', label: 'Israel', phone: '972' },
    { code: 'IT', value: 'ITA', label: 'Italy', phone: '39' },
    { code: 'MY', value: 'MYS', label: 'Malaysia', phone: '60' },
    { code: 'NO', value: 'NOR', label: 'Norway', phone: '47' },
    { code: 'PT', value: 'PRT', label: 'Portugal', phone: '351' },
    { code: 'SG', value: 'SGP', label: 'Singapore', phone: '65' },
    { code: 'ES', value: 'ESP', label: 'Spain', phone: '34' },
    { code: 'SE', value: 'SWE', label: 'Sweden', phone: '46' },
    { code: 'CH', value: 'CHE', label: 'Switzerland', phone: '41' },
    { code: 'GB', value: 'GBR', label: 'United Kingdom', phone: '44' },
    { code: 'US', value: 'USA', label: 'United States', phone: '1' },
    { code: 'VN', value: 'VNM', label: 'Viet Nam', phone: '84' }
];

const UploadIdPhoto = ({ setCheckDocument }) => {
    const { values, setFieldValue, setSubmitting } = useFormikContext();
    const fileRef = React.useRef()
    const { isLoading, mutate: callUploadPassport } = usePassport();
    React.useEffect(() => {
        if (values.applicant_verification_id.country_of_residence && fileRef.current) {
            postPhoto()
        }
        setFieldValue(formField.personal_information.country_of_residence.name, values.applicant_verification_id.country_of_residence, true)
    }, [values.applicant_verification_id.country_of_residence])

    const postPhoto = () => {
        if (!fileRef.current || isLoading) return
        const { name: fileName } = fileRef.current
        const extension = (fileName + '').match(/([^.]*)$/)?.[0]?.toLowerCase()
        callUploadPassport({
            file: fileRef.current,
            documentType: extension,
            applicantCountry: values.applicant_country,
            countryOfResidence: values.applicant_verification_id.country_of_residence
        }, {
            onSuccess: (data) => {
                setCheckDocument(true)
                dataStorage.livenessProgress = true
                setFieldValue(formField.applicant_verification_id.pass_port.name, data, false)
                // values.applicant_verification_id.pass_port = data
            },
            onError: () => {
                console.error('Cannot post image to server')
                dataStorage.showAlert('lang_upload_passport_photo_failed')
            }
        })
    }

    const onChangePassport = (file) => {
        if (!file) {
            setSubmitting(false)
            setCheckDocument(false)
            return
        }
        fileRef.current = file
        if (values.applicant_verification_id.country_of_residence) {
            postPhoto()
        }
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Typography variant='body2'><Trans>lang_upload_id_photo_tip</Trans></Typography>
            </Grid>
            <Grid item xs={12}>
                <AutocompleteField
                    required
                    name={formField.applicant_verification_id.applicant_nationality.name}
                    label={formField.applicant_verification_id.applicant_nationality.label}
                    data={countries}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12}>
                <SelectField
                    required
                    disabled
                    name={formField.applicant_verification_id.id_type.name}
                    label={formField.applicant_verification_id.id_type.label}
                    data={ID_TYPE_OPTIONS}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12}>
                <AutocompleteField
                    required
                    name={formField.applicant_verification_id.country_of_residence.name}
                    label={formField.applicant_verification_id.country_of_residence.label}
                    data={ListCountry}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12}>
                <FileUpload
                    required
                    onChange={onChangePassport}
                    name={formField.applicant_verification_id.pass_port.name}
                    label={formField.applicant_verification_id.pass_port.label}
                />
            </Grid>
        </Grid>
    )
}

export default UploadIdPhoto